<template>
  <v-card
    max-width="1102"
    outlined
    color="white"
    class="sigfloCard systemCard sigfloNeutralBorder200"
    :loading="configurator.systemsLoading"
  >
    <v-img width="64" height="64" :src="getIconImage(system.name)" class="systemIcon" />
    <div class="systemTitle sigfloH5 black--text">{{ system.name }}</div>
    <div class="systemSubtitle sigfloBodySmall textMuted">
      {{ system.description }}
    </div>
    <div class="systemTotal sigfloBody400">Subtotal: ${{ formatPrice(system.sellPrice) }}</div>
    <v-container class="subsystemContainer pl-0">
      <v-row>
        <v-col v-for="subsystem in subsystems" :key="subsystem.id">
          <SubsystemCard :subsystem="subsystem" />
        </v-col>
      </v-row>
    </v-container>
    <v-card-actions class="d-flex justify-end mr-1"
      ><v-btn rounded text color="#7C40DC" class="text-capitalize" @click="$emit('add-subsystem', system)"
        ><v-icon class="mr-2">mdi-plus-circle-outline</v-icon>Add a system</v-btn
      ></v-card-actions
    >
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';
  import SubsystemCard from './SubsystemCard.vue';

  export default {
    components: {
      SubsystemCard
    },
    props: {
      system: {
        type: Object,
        required: true
      }
    },
    data() {
      return {};
    },
    methods: {
      /**
       * Returns the icon image for the system.
       *
       * @param {string} systemName The name of the system.
       * @returns {string} The icon image for the system.
       */
      getIconImage(systemName) {
        // test for existence of image
        const defaultImage = require('@/assets/images/defaultIcon.png');
        try {
          return require(`@/assets/images/${systemName.toLowerCase()}Icon.png`);
        } catch (e) {
          return defaultImage;
        }
      }
    },
    computed: {
      ...mapState(['configurator']),
      subsystems() {
        return this.configurator.subsystems[`subsystem_${this.system.id}`];
      }
    }
  };
</script>

<style scoped>
  .subsystemContainer {
    padding-top: 100px;
  }
  .systemCard {
    position: relative;
    padding-left: 120px;
    min-height: 500px;
  }
  .systemIcon {
    position: absolute;
    left: 25px;
    top: 32px;
  }
  .systemTotal {
    position: absolute;
    top: 56px;
    right: 25px;
  }
  .systemTitle {
    position: absolute;
    top: 25px;
    left: 120px;
  }
  .systemSubtitle {
    position: absolute;
    top: 56px;
    left: 120px;
  }
  .button1 {
    color: #bcb2cd;
    font-weight: 400 !important;
  }
</style>
